export default "__VITE_ASSET__C4DgD9ck__"